export default __webpack_public_path__ + "static/media/04-observe.acdb2bff.svg";